"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PresentationControlPageInput", {
  enumerable: true,
  get: function get() {
    return _PresentationControlPageInput["default"];
  }
});
var _PresentationControlPageInput = _interopRequireDefault(require("./PresentationControlPageInput"));